import React from 'react';
import './Blog.css'
import fahim from '../../images/blog-image/fahim.jpg'
import { BsFacebook, BsLinkedin, BsInstagram, BsGithub, BsFileEarmarkPdf } from 'react-icons/bs';
import { Link } from 'react-router-dom';
import npm from '../../images/blog-image/npm.png'
import npm1 from '../../images/blog-image/npm1.jpeg'
import studyAbroad from '../../images/blog-image/study-abroad.jpg'
import visa from '../../images/blog-image/visa.jpg'
import program from '../../images/blog-image/study-program.jpg'
import useTitle from '../../Hooks/useTitle';
import { FaXTwitter } from 'react-icons/fa6';
import resume from '../../images/blog-image/resume.png'
import code from '../../images/blog-image/code.jpeg'


import ReactPrint from 'react-to-print';
import { useRef } from 'react';


import {
    TwitterShareButton,
    FacebookShareButton,
    LinkedinShareButton,
    WhatsappShareButton,
    TwitterIcon,
    FacebookIcon,
    LinkedinIcon,
    WhatsappIcon,
} from "react-share";



import { Swiper, SwiperSlide } from 'swiper/react';
import SwiperCore, { Navigation, Pagination, Autoplay } from 'swiper';
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";
import 'swiper/css/scrollbar';
import 'swiper/css/autoplay';
import { useLanguage } from '../../context/LanguageContext';
SwiperCore.use([Autoplay, Pagination]);












const Blog3Details = () => {



    const shareUrl = window.location.href
    // console.log('Current Window Location: ', window.location)
    // console.log('Current Page URL: ', window.location.href)
    // console.log('Path Name: ', window.location.pathname)

    const { language } = useLanguage()

    const ref = useRef();


    window.scrollTo(0, 0);
    useTitle('Blog-Why Study Abroad? Stories From International Students');


    const postUrl = `https://fahim-faysal-portfolio.netlify.app/blog2`;
    const postTitle = 'Why Study Abroad? Stories From International Students';
    const shareOnTwitter = () => {
        window.open(`https://twitter.com/intent/tweet?text=${postTitle}&url=${postUrl}`, '_blank');
    };
    const shareOnFacebook = () => {
        window.open(`https://www.facebook.com/sharer/sharer.php?u=${postUrl}`, '_blank');
    };
    const shareOnLinkedIn = () => {
        window.open(`https://www.linkedin.com/shareArticle?mini=true&url=${postUrl}&title=${postTitle}`, '_blank');
    };




    return (
        <div className=' mt-12 lg:px-2 md:px-2 px-0 mb-96'>


            <div className='flex justify-center lg:flex-row flex-col mb-20 lg:px-0 md:px-8 px-2 lg:gap-x-3 lg:gap-y-0 gap-x-4 gap-y-20'>



                <div className='print:hidden lg:block hidden lg:w-3/12 w-full mx-auto lg:px-4 px-1  md:left-0 fixed top-[160px]'>
                    <div className=''>
                        <div className={`bg-base-100 border-r-4 border-gray-600   rounded-lg }`}>
                            <div className="avatar flex justify-center items-center">
                                <div className="mt-2  w-[105px] rounded-full">
                                    <img className='mx-auto' src={fahim} alt='fahim' />
                                </div>
                            </div>
                            <p className='-mt-1 text-white text-2xl font-bold text-center px-6 py-3'>FAHIM FAYSAL</p>
                            <p className='-mt-1 text-[16px] text-justify px-4'>I am a full-stack developer from Bangladesh and am available to work in office or remotely.</p>
                            <p className='mt-3 text-[16px] text-amber-500 text-justify px-4'>Expert In: <span className='text-white'>ReactJS, NodeJS, MongoDB, Redux, Firebase</span></p>
                            <div className='flex justify-center items-center gap-x-4 mt-4'>
                                <div className=''>
                                    <a href='https://github.com/Fahimsakib1?tab=repositories' target='blank' className='tooltip' data-tip='GitHub'>
                                        <BsGithub className='text-white text-2xl my-2 hover:bg-black hover:text-white rounded-lg transition ease-in-out delay-150 hover:-translate-y-1 hover:scale-105 duration-300' ></BsGithub>
                                    </a>
                                </div>
                                <div className=''>
                                    <a href='https://www.linkedin.com/in/fahim-faysal/' target='blank' className='tooltip' data-tip='LinkedIn'>
                                        <BsLinkedin className='text-white text-2xl my-2 hover:text-blue-700 transition ease-in-out delay-150 hover:-translate-y-1 hover:scale-105 duration-300' ></BsLinkedin>
                                    </a>
                                </div>
                                <div className=' '>
                                    <a href='https://www.instagram.com/i_fahiim/' target='blank' className='tooltip' data-tip='Instagram'>
                                        <BsInstagram className='text-white text-2xl my-2 hover:text-rose-500 transition ease-in-out delay-150 hover:-translate-y-1 hover:scale-105 duration-300' ></BsInstagram>
                                    </a>
                                </div>
                                <div className=''>
                                    <a href='https://www.facebook.com/fahim.sakib.5' target='blank' className='tooltip' data-tip='Facebook'>
                                        <BsFacebook className='text-white text-2xl my-2 hover:text-blue-500 transition ease-in-out delay-150 hover:-translate-y-1 hover:scale-105 duration-300' ></BsFacebook>
                                    </a>
                                </div>
                            </div>
                            <Link to='/contact'>
                                <div className='w-full mt-3 mx-auto text-center cursor-pointer'>
                                    <button className=' text-lg w-full px-16 py-2 bg-rose-700 hover:bg-rose-800 rounded-sm text-white'>Hire Me</button>
                                </div>
                            </Link>
                        </div>
                    </div>
                </div>













                <div className='lg:ml-[355px] lg:w-6/12 w-full mx-auto bg-white screen:shadow-2xl print:shadow-none md:px-6 px-2 py-8 ml:0'>



                    <div>


                        <div ref={ref} className='bg-white text-black mt-6'>

                            {
                                language === 'english' ?
                                    <>
                                        <h2 className='font-sans md:text-4xl text-[27px] text-justify font-bold text-black mb-3'>Why Study Abroad? Stories From International Students</h2>
                                        <p className='mt-8 text-justify px-2 text-gray-900 font-serif  md:text-[19px] text-[17px]'> You might find a degree course that isn’t available in your home country; you might learn to live independently; or you might network with amazing people and learn about other cultures. Whatever your reason for considering the experience, there are so many more positives. And if you don’t believe us, just look at what real students had to say about studying abroad.</p>
                                    </>
                                    :
                                    <>
                                        <h2 className='font-sans lg:text-[30px] md:text-[30px] text-[23px] text-justify font-bold text-black mb-3'>কেন আপনি বিদেশে পড়াশুনা করবেন? আন্তর্জাতিক ছাত্রদের থেকে শুনুন</h2>
                                        <p className='mt-8 text-justify px-2 text-gray-900 font-serif  md:text-[19px] text-[17px]'> আপনি একটি ডিগ্রি কোর্স খুঁজে পেতে পারেন যা আপনার দেশে উপলব্ধ নয়; আপনি স্বাধীনভাবে বাঁচতে শিখতে পারেন; অথবা আপনি আশ্চর্যজনক লোকেদের সাথে নেটওয়ার্ক করতে পারেন এবং অন্যান্য সংস্কৃতি সম্পর্কে জানতে পারেন। অভিজ্ঞতা বিবেচনা করার জন্য আপনার কারণ যাই হোক না কেন, আরও অনেক ইতিবাচক দিক রয়েছে। এবং যদি আপনি আমাদের বিশ্বাস না করেন, শুধু দেখুন বিদেশে অধ্যয়ন করার বিষয়ে প্রকৃত শিক্ষার্থীরা কী বলে।</p>
                                    </>
                            }


                            <div>
                                <img className='md:h-80 h-64 w-full my-8' src={studyAbroad} alt="BlogImage" />
                            </div>

                            {
                                language === 'english' ?
                                    <>
                                        <p className='mt-5 text-justify px-2 text-gray-800  text-[17px]'>
                                            The American university experience is unlike any other in the world and certainly very distinct from my home country, India. I was particularly drawn to the academic possibilities. As an undergraduate, you can study a range of subjects, and most universities don’t require you to declare your major until your junior year, giving you time to explore a variety of academic paths and see what interests you. Some universities, including my own, require undergraduates to take a core curriculum of classes, developing the basics. Your course can be customisable, allowing you to choose multiple majors and minors, change things as you go along, and take electives that are unrelated to your main areas of study.
                                        </p>

                                        <p className='mt-5 text-justify px-2 text-gray-800  text-[17px]'>
                                            I really benefited from this diverse way of learning. I entered university committed to studying politics, but my discovery of college-level English literature classes was transformative and reoriented my interests in a way that could never have happened without the freedom that the US system encourages and celebrates. Moving to Dublin for my university education in 2020 came with so much excitement and a little bit of nerves. Nevertheless, I stayed optimistic about starting something that was once a dream – studying medicine. Studying abroad meant learning to live independently, which has allowed me to grow as an individual, overcome everyday challenges and build life skills such as managing my finances.
                                        </p>

                                        <p className='mt-5 text-justify px-2 text-gray-800  text-[17px]'>
                                            Studying abroad has also given me the opportunity to experience a style of education different from that in my home country, Nigeria. By exploring the environment around me, travelling, taking up volunteer work and through learning in the classroom, I am beginning to see the world and gain new perspectives. During my time in Ireland so far, I have also been able to develop long-lasting friendships and create beautiful memories with people from diverse backgrounds and countries including Trinidad and Tobago, Malaysia, Canada, Iraq and many more. Finally, I have discovered new interests and found new hobbies including kick-boxing, something I might not have discovered if I stayed back in my home country.
                                        </p>

                                        <p className='mt-5 text-justify px-2 text-gray-800  text-[17px]'>
                                            Studying abroad has been a life-changing experience so far. One of the benefits of studying abroad is learning more about yourself outside your comfort zone. At first, you might struggle, feel homesick and even question whether you made the right choice. However, as time passes, you learn more about yourself and how to cope with problems on your own. The things that have made you feel anxious before, like having your final exam, later seem like minor problems that you can handle. Eventually, you feel less scared and will learn independence. My experience when I first came to Canada from my home in Turkey was like being a swimmer without a lifeline in the ocean. Eventually, I learned how to surf the waves and enjoyed new ones as they came. In the end, studying abroad has benefited me beyond the academics; I also found myself.
                                        </p>
                                    </>
                                    :
                                    <>
                                        <p className='mt-5 text-justify px-2 text-gray-800  text-[17px]'>
                                            আমেরিকান ইউনিভার্সিটির অভিজ্ঞতা পৃথিবীর অন্য যে কোনো কিছুর মতো নয় এবং অবশ্যই আমার নিজ দেশ ভারত থেকে খুব আলাদা। আমি বিশেষ করে একাডেমিক সম্ভাবনার প্রতি আকৃষ্ট হয়েছিলাম। একজন আন্ডারগ্র্যাজুয়েট হিসেবে, আপনি বিভিন্ন বিষয় অধ্যয়ন করতে পারেন, এবং বেশিরভাগ বিশ্ববিদ্যালয়ে আপনার জুনিয়র বছর পর্যন্ত আপনার মেজর ঘোষণা করার প্রয়োজন হয় না, আপনাকে বিভিন্ন ধরনের একাডেমিক পথ অন্বেষণ করতে এবং আপনার আগ্রহগুলি দেখতে সময় দেয়। আমার নিজের সহ কিছু বিশ্ববিদ্যালয়ে প্রাথমিক বিষয়গুলি বিকাশের জন্য ক্লাসের একটি মূল পাঠ্যক্রম নেওয়ার জন্য স্নাতকদের প্রয়োজন। আপনার কোর্সটি কাস্টমাইজ করা যেতে পারে, আপনাকে একাধিক প্রধান এবং অপ্রাপ্তবয়স্কদের বেছে নিতে, আপনার সাথে চলার সাথে সাথে জিনিসগুলি পরিবর্তন করতে এবং আপনার অধ্যয়নের প্রধান ক্ষেত্রগুলির সাথে সম্পর্কিত নয় এমন ইলেক্টিভগুলি নেওয়ার অনুমতি দেয়৷
                                        </p>

                                        <p className='mt-5 text-justify px-2 text-gray-800  text-[17px]'>
                                            আমি সত্যিই শেখার এই বিভিন্ন উপায় থেকে উপকৃত হয়েছে. আমি রাজনীতি অধ্যয়নের জন্য প্রতিশ্রুতিবদ্ধ বিশ্ববিদ্যালয়ে প্রবেশ করেছি, কিন্তু কলেজ-স্তরের ইংরেজি সাহিত্যের ক্লাসগুলির আমার আবিষ্কারটি রূপান্তরমূলক ছিল এবং আমার আগ্রহগুলিকে এমনভাবে পুনর্নির্মাণ করেছিল যা মার্কিন সিস্টেম যে স্বাধীনতাকে উত্সাহিত করে এবং উদযাপন করে তা ছাড়া কখনই ঘটত না। 2020 সালে আমার বিশ্ববিদ্যালয়ের শিক্ষার জন্য ডাবলিনে চলে আসা অনেক উত্তেজনা এবং কিছুটা স্নায়ু নিয়ে এসেছিল। তবুও, আমি এমন কিছু শুরু করার বিষয়ে আশাবাদী রয়েছি যা একসময় স্বপ্ন ছিল – মেডিসিন অধ্যয়ন। বিদেশে অধ্যয়ন করার অর্থ স্বাধীনভাবে বাঁচতে শেখা, যা আমাকে একজন ব্যক্তি হিসাবে বেড়ে উঠতে, প্রতিদিনের চ্যালেঞ্জগুলি কাটিয়ে উঠতে এবং আমার আর্থিক ব্যবস্থাপনার মতো জীবন দক্ষতা তৈরি করতে দেয়।
                                        </p>

                                        <p className='mt-5 text-justify px-2 text-gray-800  text-[17px]'>
                                            বিদেশে অধ্যয়ন করা আমাকে আমার নিজ দেশ নাইজেরিয়া থেকে ভিন্ন শিক্ষার শৈলীর অভিজ্ঞতার সুযোগ দিয়েছে। আমার চারপাশের পরিবেশ অন্বেষণ, ভ্রমণ, স্বেচ্ছাসেবক কাজ গ্রহণ এবং শ্রেণীকক্ষে শেখার মাধ্যমে, আমি বিশ্বকে দেখতে এবং নতুন দৃষ্টিভঙ্গি অর্জন করতে শুরু করছি। এখন পর্যন্ত আয়ারল্যান্ডে থাকাকালীন, আমি দীর্ঘস্থায়ী বন্ধুত্ব গড়ে তুলতে এবং ত্রিনিদাদ এবং টোবাগো, মালয়েশিয়া, কানাডা, ইরাক এবং আরও অনেকগুলি সহ বিভিন্ন পটভূমি এবং দেশগুলির লোকদের সাথে সুন্দর স্মৃতি তৈরি করতে সক্ষম হয়েছি। অবশেষে, আমি নতুন আগ্রহ খুঁজে পেয়েছি এবং কিকবক্সিং সহ নতুন শখ খুঁজে পেয়েছি, যা আমি আমার দেশে ফিরে থাকলে হয়তো আবিষ্কার করতে পারতাম না।
                                        </p>

                                        <p className='mt-5 text-justify px-2 text-gray-800  text-[17px]'>
                                            বিদেশে অধ্যয়ন করা এখন পর্যন্ত একটি জীবন পরিবর্তনকারী অভিজ্ঞতা। বিদেশে অধ্যয়নের সুবিধাগুলির মধ্যে একটি হল আপনার কমফোর্ট জোনের বাইরে নিজের সম্পর্কে আরও শেখা। প্রথমে, আপনি হয়তো সংগ্রাম করতে পারেন, গৃহস্থ বোধ করতে পারেন এবং এমনকি প্রশ্ন করতে পারেন আপনি সঠিক পছন্দ করেছেন কিনা। যাইহোক, সময় অতিবাহিত হওয়ার সাথে সাথে, আপনি নিজের সম্পর্কে আরও শিখবেন এবং কীভাবে নিজেই সমস্যাগুলি মোকাবেলা করবেন। যে বিষয়গুলি আপনাকে আগে উদ্বিগ্ন করে তুলেছিল, যেমন আপনার চূড়ান্ত পরীক্ষা, পরে মনে হয় ছোটখাটো সমস্যা যা আপনি পরিচালনা করতে পারেন। অবশেষে, আপনি কম ভয় পাবেন এবং স্বাধীনতা শিখবেন। তুরস্কে আমার বাড়ি থেকে যখন আমি প্রথম কানাডায় আসি তখন আমার অভিজ্ঞতা ছিল সাগরে লাইফলাইন ছাড়া একজন সাঁতারু হওয়ার মতো। অবশেষে, আমি শিখেছি কিভাবে তরঙ্গ সার্ফ করতে হয় এবং নতুন তরঙ্গ আসার সাথে সাথে উপভোগ করেছি। শেষ পর্যন্ত, বিদেশে পড়াশোনা আমাকে শিক্ষাবিদদের বাইরেও উপকৃত করেছে; আমিও নিজেকে খুঁজে পেয়েছি।
                                        </p>
                                    </>
                            }

                        </div>


                        <ReactPrint trigger={() => <button className='print:hidden ml-1 hover:scale-105 mt-28 mb-16 px-6 py-2 bg-green-600 text-white'>
                            <div className='text-[16px] text-white flex justify-start items-center gap-x-1'>
                                <BsFileEarmarkPdf size={25} className='text-white'></BsFileEarmarkPdf>
                                {
                                    language === 'english' ?
                                        <p>Download PDF</p>
                                        :
                                        <p>ডাউনলোড পিডিএফ</p>
                                }
                            </div>
                        </button>} content={() => ref.current}>
                        </ReactPrint>



                        {
                            language === 'english' ?
                                <h1 className='print:hidden mt-20 lg:mb-4 mb-3 md:text-3xl text-2xl text-start text-black font-bold'>Share This Post</h1>
                                :
                                <h1 className='print:hidden mt-20 lg:mb-4 mb-3 md:text-3xl text-2xl text-start text-black font-bold'>পোস্টটি শেয়ার করুন</h1>
                        }
                        <div className='print:hidden flex justify-start items-center'>
                            <div className='hover:scale-110 hover:duration-200 hover:delay-150 ease-out hover:-translate-y-1 cursor-pointer tooltip' data-tip='Share on Facebook'>
                                <FacebookShareButton
                                    url={shareUrl}
                                    quote={'Share Blog on Facebook'}
                                    hashtag={'#blog'}
                                    style={{ marginRight: '7px' }}
                                >
                                    <FacebookIcon size={38} round={true} />
                                </FacebookShareButton>
                            </div>
                            <div className='hover:scale-110 hover:duration-200 hover:delay-150 ease-out hover:-translate-y-1 cursor-pointer tooltip' data-tip='Share on Twitter'>
                                <TwitterShareButton
                                    url={shareUrl}
                                    quote={'Share Blog on Twitter'}
                                    hashtag={'#blog'}
                                    style={{ marginRight: '7px' }}
                                >
                                    <TwitterIcon size={38} round={true} />
                                </TwitterShareButton>
                            </div>
                            <div className='hover:scale-110 hover:duration-200 hover:delay-150 ease-out hover:-translate-y-1 cursor-pointer tooltip' data-tip='Share on LinkedIn'>
                                <LinkedinShareButton
                                    url={shareUrl}
                                    quote={'Share Blog on LinkedIn'}
                                    hashtag={'#blog'}
                                    style={{ marginRight: '7px' }}
                                >
                                    <LinkedinIcon size={38} round={true} />
                                </LinkedinShareButton>
                            </div>
                            <div className='hover:scale-110 hover:duration-200 hover:delay-150 ease-out hover:-translate-y-1 cursor-pointer tooltip' data-tip='Share on WhatsApp'>
                                <WhatsappShareButton
                                    url={shareUrl}
                                    quote={'Share Blog on WhatsApp'}
                                    hashtag={'#blog'}
                                    style={{ marginRight: '7px' }}
                                >
                                    <WhatsappIcon size={38} round={true} />
                                </WhatsappShareButton>
                            </div>
                        </div>


                    </div>






                </div>







                





                <div className='print:hidden lg:w-3/12 w-full mx-auto lg:px-4 px-1 '>
                    <div className='lg:right-auto lg:fixed lg:top-[160px] lg:mr-10 relative'>
                        <div className={`bg-gray-700 rounded-sm px-3 pt-2 pb-2`}>
                            <p className='text-white text-center text-lg -mt-1 px-6 py-1'>Read More Blogs... </p>
                            <div>
                                <Link to='/blog5'>
                                    <div className=' hover:border-blue-500 cursor-pointer  gap-x-3 mb-2 mt-1 border-2 px-2 py-2 border-white rounded-sm flex lg:justify-center md:justify-start justify-start items-center group' title='Read Blog'>
                                        <div className="avatar">
                                            <div className="w-16 rounded">
                                                <img src={program} alt='pictures' />
                                            </div>
                                        </div>
                                        <p className='text-start text-yellow-400 group-hover:text-white  md:text-lg lg:text-[16px]  text-md '>4 Reasons Why Year Gap In Study Isn't End of life</p>
                                    </div>
                                </Link>


                                <Link to='/blog7'>
                                    <div className=' hover:border-blue-500 cursor-pointer gap-x-3 mb-2 mt-1 border-2 px-2 py-2 border-white rounded-sm flex lg:justify-center md:justify-start justify-start items-center group' title='Read Blog'>
                                        <div className="avatar">
                                            <div className="w-16 rounded">
                                                <img src={resume} alt='pictures' />
                                            </div>
                                        </div>
                                        <p className='text-yellow-400 group-hover:text-white  md:text-lg lg:text-[16px]  text-md '>How To Improve Your Resume In 9 Steps</p>
                                    </div>
                                </Link>


                                <Link to='/blog6'>
                                    <div className=' hover:border-blue-500 cursor-pointer gap-x-3 mb-2 mt-1 border-2 px-2 py-2 border-white rounded-sm flex lg:justify-center md:justify-start justify-start items-center group' title='Read Blog'>
                                        <div className="avatar">
                                            <div className="w-16 rounded">
                                                <img src={code} alt='pictures' />
                                            </div>
                                        </div>
                                        <p className='text-start text-yellow-400 group-hover:text-white md:text-lg lg:text-[16px]  text-md '>Tips For Writing Comments In Your Code</p>
                                    </div>
                                </Link>

                                <Link to='/blog1'>
                                    <div className='hover:border-blue-500 cursor-pointer gap-x-3 mb-2 mt-1 border-2 px-2 py-2 border-white rounded-sm flex lg:justify-center md:justify-start justify-start items-center group' title='Read Blog'>
                                        <div className="avatar">
                                            <div className="w-16 rounded">
                                                <img src={npm} alt='pictures' />
                                            </div>
                                        </div>
                                        <p className='md:text-lg lg:text-[16px] text-md text-yellow-400 group-hover:text-white '>7 Most Popular Animation Libraries For React</p>
                                    </div>
                                </Link>


                                {/* <div className=' -mt-12 lg:w-[300px] md:w-[680px] sm:w-[350px] w-[350px]  '>
                                    <Swiper
                                        pagination={{
                                            clickable: true
                                        }}
                                        modules={[Pagination, Autoplay, Navigation]}
                                        autoplay={{ delay: 2000 }}
                                        className="mySwiper"
                                    >

                                        <SwiperSlide className=''>
                                            <div>
                                                <Link to='/blog5'>
                                                    <div className=' hover:border-blue-500 cursor-pointer lg:w-[300px] md:w-[680px] w-[350px]  gap-x-3 mb-3 mt-1 border-2 px-2 py-2 border-white rounded-sm flex lg:justify-center md:justify-start justify-center items-center'>
                                                        <div className="avatar">
                                                            <div className="w-16 rounded">
                                                                <img src={program} alt='pictures' />
                                                            </div>
                                                        </div>
                                                        <p className='text-start text-yellow-400 underline md:text-lg lg:text-[16px]  text-md '>4 Reasons Why Year Gap In Study Isn't End of life</p>
                                                    </div>
                                                </Link>
                                                <Link to='/blog2'>
                                                    <div className='hover:border-blue-500 lg:w-[300px] md:w-[680px] w-[350px]  cursor-pointer gap-x-3 mt-1 border-2 px-2 py-2 border-white rounded-sm flex lg:justify-center md:justify-start justify-center items-center'>
                                                        <div className="avatar">
                                                            <div className="w-16 rounded">
                                                                <img src={npm1} alt='pictures' />
                                                            </div>
                                                        </div>
                                                        <p className='text-start md:text-lg lg:text-[16px] text-md text-yellow-400 underline'>Worst npm Packages you should not use</p>
                                                    </div>
                                                </Link>

                                            </div>
                                        </SwiperSlide>


                                        <SwiperSlide className=''>
                                            <div>

                                                <Link to='/blog6'>
                                                    <div className=' hover:border-blue-500 lg:w-[300px] md:w-[680px] w-[350px] cursor-pointer gap-x-3 mb-3 mt-1 border-2 px-2 py-2 border-white rounded-sm flex lg:justify-center md:justify-start justify-center items-center'>
                                                        <div className="avatar">
                                                            <div className="w-16 rounded">
                                                                <img src={code} alt='pictures' />
                                                            </div>
                                                        </div>
                                                        <p className='text-start text-yellow-400 underline md:text-lg lg:text-[16px]  text-md '>Tips For Writing Comments In Your Code</p>
                                                    </div>
                                                </Link>

                                                <Link to='/blog4'>
                                                    <div className=' hover:border-blue-500 lg:w-[300px] md:w-[680px] w-[350px] cursor-pointer gap-x-3  mt-1 border-2 px-2 py-2 border-white rounded-sm flex lg:justify-center md:justify-start justify-center items-center'>
                                                        <div className="avatar">
                                                            <div className="w-16 rounded">
                                                                <img src={visa} alt='pictures' />
                                                            </div>
                                                        </div>
                                                        <p className='text-start text-yellow-400 underline md:text-lg lg:text-[16px]  text-md '>Everything You Need to Know about Student Visa</p>
                                                    </div>
                                                </Link>
                                            </div>
                                        </SwiperSlide>

                                    </Swiper>
                                </div> */}

                            </div>
                        </div>
                    </div>
                </div>




            </div>



        </div>
    );
};

export default Blog3Details;